import {
  AZURE_CLIENT_ID,
  AZURE_TENANT_ID,
  AZURE_REDIRECT_URI,
} from "@/constants/endpoints";
import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    //Data needed from Azure

    clientId: AZURE_CLIENT_ID, // ID de la aplicación registrada en Azure
    authority: `https://login.microsoftonline.com/${AZURE_TENANT_ID}`, // ID del tenant o dominio de tu organización
    redirectUri: AZURE_REDIRECT_URI, // Redirecciona a esta URI después de la autenticación
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
